var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.18,4.349A8.021,8.021,0,1,0,5.859,15.714l4.972,5a.941.941,0,0,0,1.34,0l5.009-5.048A8.025,8.025,0,0,0,17.18,4.349Zm-1.349,9.964L11.52,18.659,7.208,14.312a6.106,6.106,0,1,1,8.623,0ZM8.689,7.124a4.1,4.1,0,0,0,0,5.777,4.067,4.067,0,1,0,0-5.777Zm4.424,4.432a.911.911,0,1,0-.047,0Z",
    transform: "translate(-3.515 -1.995)",
    fill: "#00dfa3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPoint);
export default __webpack_public_path__ + "static/media/location-point.c3ad1b65ddd9ed30cd7f6b0c2128e847.svg";
export { ForwardRef as ReactComponent };